import React from "react";
import { cn } from "@/helpers/utils";
import { useCardContext } from "./CardContext";
import { VariantProps, cva } from "class-variance-authority";

export const cardActions = cva("grid gap-4", {
  variants: {
    orientation: {
      horizontal: "grid-flow-col auto-cols-fr",
      vertical: "grid-flow-row",
      responsive: "grid-flow-row md:grid-flow-col md:auto-cols-fr",
    },
  },
  defaultVariants: { orientation: "horizontal" },
});

interface CardActionsProps extends VariantProps<typeof cardActions> {
  children?: React.ReactNode;
}

export const CardActions = ({ children, orientation }: CardActionsProps) => {
  const { bordered, rounded, hoverable } = useCardContext();
  return (
    <div
      className={cn(
        "card-actions",
        cardActions({ orientation }),
        hoverable == "expand" &&
          "absolute left-0 !mt-0 w-full bg-white p-4 shadow-lg transition-all",
        hoverable == "expand" &&
          bordered &&
          "border border-t-0 border-solid border-primary-100",
        hoverable == "expand" && rounded && "rounded-b-lg",
        hoverable == "expand" && "hidden group-hover:grid"
      )}
    >
      {children}
    </div>
  );
};
